import { PageHeader, AikoInvite } from "./shared";
import { useLocation } from "wouter";

/**
 * Fallback route for any /app/<x> not explicitly named (e.g. /reports,
 * /payments, /inventory, /outlets, /users, /news). Existing users
 * navigating from the original sidebar land here with a familiar invite
 * to Aiko, who renders the section's body via the generative-UI engine.
 */
export function GenerativePage() {
  const [loc] = useLocation();
  const slug = loc.replace(/^\/app\//, "").replace(/\/.*$/, "");
  const title = slug.replace(/(^.|\s.)/g, (c) => c.toUpperCase()) || "Section";
  return (
    <div className="space-y-6">
      <PageHeader
        title={title}
        subtitle="Aiko renders this section bound to your real outlets."
      />
      <AikoInvite suggestion={`Show me my ${slug}`} />
    </div>
  );
}
